import {
  ChipRemove,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@aircall/ds";
import { useParams } from "react-router";
import { TagBeautified } from "@/components/TagBeautified/TagBeautified";
import { trimWithEllipsis } from "@/helpers/string/string.helpers";
import { useLinkTagsToCall } from "@/hooks/useLinkToTags/useLinkTagsToCall";
import { useBaseStore } from "@/store/store";
import { RouteParams } from "../Transcription/Transcription.decl";
import { MAX_LENGTH } from "./TagsListItem.constants";
import { TagsListItemProps } from "./TagsListItem.decl";
import { useTracking } from "./TagsListItem.hooks";

export function TagsListItem({ color, name, id }: TagsListItemProps) {
  const { callId } = useParams<RouteParams>();
  const { onClick: handleOnClickTrack } = useTracking();

  const tagIds = useBaseStore((state) => state.tagIds);
  const setTagIds = useBaseStore((state) => state.setTagIds);

  const { updateTags } = useLinkTagsToCall({ callId: callId! });

  const handleOnClick = () => {
    const filtered = tagIds.filter((tagId) => tagId !== id);

    handleOnClickTrack();
    updateTags(filtered);
    setTagIds(filtered);
  };

  if (!name) {
    return null;
  }

  const tag = (
    <TagBeautified color={color} data-test={`tags-list-item-${name}`}>
      <span className="text-tiny font-medium">
        {trimWithEllipsis(name, MAX_LENGTH)}
      </span>
      <ChipRemove
        data-test={`tags-list-item-delete-${name}`}
        onClick={handleOnClick}
      />
    </TagBeautified>
  );

  if (name.length > MAX_LENGTH) {
    return (
      <Tooltip>
        <TooltipTrigger render={<span />}>{tag}</TooltipTrigger>
        <TooltipContent side="top" align="center">
          {name}
        </TooltipContent>
      </Tooltip>
    );
  }

  return tag;
}
